import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function WorkspaceOpenerCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-indigo-200 bg-indigo-50 p-4 text-sm text-indigo-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-indigo-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Workspace
        </span>
        {typeof answer.matter_count === 'number' && (
          <span className="text-xs text-indigo-800">
            {answer.matter_count} active matter{answer.matter_count === 1 ? '' : 's'}
          </span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
